module.exports = __webpack_public_path__ + "media/55e790ff-904b-4a27-86cb-ee20173a0518.ddd522f8.mp4";